import { declareString } from "@1js/localization";

export const NoResultV2Heading = declareString(
  "promptLibrary.noResultV2Heading",
  {
    text: "We didn't find any results",
    comment: "Heading displayed if filter returns zero results.",
  }
);

export const NoResultV2SubHeading = declareString(
  "promptLibrary.noResultV2Subheading",
  {
    text: "Try changing one or more filters.",
    comment: "Subheading displayed if filter returns zero results.",
  }
);
